import React from 'react'
import CustomDialog from 'sharedComponents/customDialog'
import useStyles from './style'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { Grid, TextField } from '@mui/material'
import contactApi from 'services/contactUs'
import { showLoader, hideLoader } from 'redux/loader/actions'
import { showSnackbar } from 'redux/snackbar/actions'
import { useDispatch } from 'react-redux'

const ContactUsModal = (props) => {
  const { open, handleClose, title, btnLabel } = props
  const classes = useStyles()
  const dispatch = useDispatch()

  // Send contact request
  const handleContactUs = (formValues) => {
    dispatch(showLoader('Loading please wait...'))
    const data = {
      name: formValues?.name,
      mobilenum: formValues?.mobileNo,
      email: formValues?.email,
      message: formValues?.message,
    }
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        dispatch(
          showSnackbar({
            message: res?.data?.message || 'Request sent successfully',
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            variant: 'success',
          })
        )
        formik?.resetForm()
        handleClose()
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || 'Failed to fetch data',
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          variant: 'error',
        })
      )
      console.log('send contact request Api', err)
    }

    contactApi.sendContact({ ...data }).then(onSuccess, onFailure)
  }

  const formik = useFormik({
    initialValues: {
      name: "",
      mobileNo: "",
      email: "",
      message: "",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      name: yup.string().trim().required("Name is required"),
      mobileNo: yup
        .string()
        .required("Mobile number is required")
        .matches(/^[0-9]+$/, "Only Numbers are allowed")
        .max(10, `Max 10 digits are allowed`)
        .min(10, `Must be exactly 10 numbers`)
        .nullable(),
      email: yup
        .string()
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Invalid email address"
        )
        .email("Enter a valid email address"),
      message: yup.string().max(500, "Maximum 500 characters are allowed"),
    }),
    onSubmit: handleContactUs,
  });

  return (
    <>
      <CustomDialog
        open={open}
        handleClose={() => {
          handleClose()
          formik.resetForm()
        }}
        title={title}
        btnLabel={btnLabel}
        onSubmit={formik?.handleSubmit}
      >
        <Grid container flexDirection={'column'} className={classes.root}>
          <Grid item xs={12} sm={6}>
            <TextField
              name="name"
              id="name"
              value={formik?.values?.name}
              onChange={formik?.handleChange}
              type={'text'}
              fullWidth
              variant="outlined"
              label="Name*"
              size="small"
              error={formik?.errors?.name && formik?.touched?.name}
              helperText={
                formik?.errors?.name &&
                formik?.touched?.name &&
                formik?.errors?.name
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="mobileNo"
              id="mobileNo"
              value={formik?.values?.mobileNo}
              onChange={formik?.handleChange}
              type={'text'}
              fullWidth
              variant="outlined"
              label="Mobile No*"
              size="small"
              error={formik?.errors?.mobileNo && formik?.touched?.mobileNo}
              helperText={
                formik?.errors?.mobileNo &&
                formik?.touched?.mobileNo &&
                formik?.errors?.mobileNo
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="email"
              id="email"
              value={formik?.values?.email}
              onChange={formik?.handleChange}
              type={'text'}
              fullWidth
              variant="outlined"
              label="Email"
              size="small"
              error={formik?.errors?.email && formik?.touched?.email}
              helperText={
                formik?.errors?.email &&
                formik?.touched?.email &&
                formik?.errors?.email
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="message"
              id="message"
              value={formik?.values?.message}
              onChange={formik?.handleChange}
              type={'text'}
              fullWidth
              variant="outlined"
              label="Message"
              size="small"
              multiline
              rows={5}
              rowsMax={5}
              error={formik?.errors?.message && formik?.touched?.message}
              helperText={
                formik?.errors?.message &&
                formik?.touched?.message &&
                formik?.errors?.message
              }
            />
          </Grid>
        </Grid>
      </CustomDialog>
    </>
  )
}

export default ContactUsModal
